import { render, staticRenderFns } from "./ArgForm.vue?vue&type=template&id=52c46819"
import script from "./ArgForm.vue?vue&type=script&lang=js"
export * from "./ArgForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports